module.exports = __webpack_public_path__ + "static/media/tokiwa10-4.93f0b1e7.jpg";